import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { P00058EcremageTimerEnum } from '../../../Enum/P00058EcremageTimerEnum';
import {
  P00058SpeedDefaultValue,
  P00058SpeedEnum,
} from '../../../Enum/P00058SpeedEnum';
import { P00058AmorcageTimerEnum } from '../../../Enum/P00058AmorcageTimerEnum';
import { P00058EnSavoirPlusComponent } from '../../../EnSavoirPlus/p00058-en-savoir-plus/p00058-en-savoir-plus.component';
import { P00058BathingTimerEnum } from '../../../Enum/P00058BathingTimerEnum';
import { FunctionParametersSettingsClockPompeVSScreenComponent } from '../../../Component/function-parameters-settings-clock-pompe-vsscreen/function-parameters-settings-clock-pompe-vsscreen.component';
import { FunctionParametersSettingClockWeekPompeVSScreenComponent } from '../../../Component/function-parameters-setting-clock-week-pompe-vsscreen/function-parameters-setting-clock-week-pompe-vsscreen.component';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P00058ProgrammeFiltrationAuto } from '../../../Enum/P00058ProgrammeFiltrationAuto';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P00058SeuilTemperatureFiltration2424 } from '../../../Enum/P00058SeuilTemperatureFiltration2424';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { IonLabel } from '@ionic/angular/standalone';
import { P00058SeuilTemperatureHorsGel } from '../../../Enum/P00058SeuilTemperatureHorsGel';
import { P00058CapteurTemperatureEnum } from '../../../Enum/P00058CapteurTemperatureEnum';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';

@Component({
  selector: 'app-p00058-filtration-parameters',
  templateUrl: './p00058-filtration-parameters.component.html',
  styleUrls: ['./p00058-filtration-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    TranslatePipe,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TwoChoicesControlComponent,
    SwitchConfigurationComponent,
    IonLabel,
  ],
})
export class P00058FiltrationParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  public translateService: TranslateService = inject(TranslateService);
  private slideModalController: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.getEnSavoirPlus = this.getEnSavoirPlus.bind(this);
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
    this.openEnSavoirPlus2 = this.openEnSavoirPlus2.bind(this);
  }

  getAmorcageTimerEnum() {
    return P00058AmorcageTimerEnum(this.translateService);
  }
  getSpeedEnum(min: number, max: number) {
    return P00058SpeedEnum(
      this.translateService,
      this.actionStack!.getValue('pvPUniteConsignePompe'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      min,
      max,
      5,
      this.actionStack!.getValue('pvSVitesseMinRpm'),
      this.actionStack!.getValue('pvSVitesseMaxRpm'),
      100,
    );
  }

  async openEnSavoirPlus2() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00058.installation.bathing.enSavoirPlus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalController.create({
      component: P00058EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getBathingTimer() {
    return P00058BathingTimerEnum(this.translateService);
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingClockWeekPompeVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvPHorlogeSemaineHivers'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage10,
        'pvPHorlogeSemaineHivers',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingsClockPompeVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('pvPHorlogeJourHiversLundi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversMardi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversMercredi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversJeudi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversVendredi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversSamedi') +
          this.actionStack!.getValue('pvPHorlogeJourHiversDimanche'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage11,
        'pvPHorlogeJourHiversLundi',
        hj.substring(0, 96),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage12,
        'pvPHorlogeJourHiversMardi',
        hj.substring(96, 192),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage13,
        'pvPHorlogeJourHiversMercredi',
        hj.substring(192, 288),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage14,
        'pvPHorlogeJourHiversJeudi',
        hj.substring(288, 384),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage15,
        'pvPHorlogeJourHiversVendredi',
        hj.substring(384, 480),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage16,
        'pvPHorlogeJourHiversSamedi',
        hj.substring(480, 576),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage17,
        'pvPHorlogeJourHiversDimanche',
        hj.substring(576, 672),
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekPPEScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingClockWeekPompeVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('pvPHorlogeSemaineEte'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage2,
        'pvPHorlogeSemaineEte',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingsClockPEEScreen() {
    const modal = await this.slideModalController.create({
      component: FunctionParametersSettingsClockPompeVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('pvPHorlogeJourEteLundi') +
          this.actionStack!.getValue('pvPHorlogeJourEteMardi') +
          this.actionStack!.getValue('pvPHorlogeJourEteMercredi') +
          this.actionStack!.getValue('pvPHorlogeJourEteJeudi') +
          this.actionStack!.getValue('pvPHorlogeJourEteVendredi') +
          this.actionStack!.getValue('pvPHorlogeJourEteSamedi') +
          this.actionStack!.getValue('pvPHorlogeJourEteDimanche'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage3,
        'pvPHorlogeJourEteLundi',
        hj.substring(0, 96),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage4,
        'pvPHorlogeJourEteMardi',
        hj.substring(96, 192),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage5,
        'pvPHorlogeJourEteMercredi',
        hj.substring(192, 288),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage6,
        'pvPHorlogeJourEteJeudi',
        hj.substring(288, 384),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage7,
        'pvPHorlogeJourEteVendredi',
        hj.substring(384, 480),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage8,
        'pvPHorlogeJourEteSamedi',
        hj.substring(480, 576),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.PompeVS_Parametrage9,
        'pvPHorlogeJourEteDimanche',
        hj.substring(576, 672),
      );
      this.actionStack!.commit();
    }
  }

  async getEnSavoirPlus() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P00058.installation.ecremage.enSavoirPlus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  getEcremageTimerEnum() {
    return P00058EcremageTimerEnum(this.translateService);
  }

  async getSpeedUnitInformation() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description:
          this.translateService.instant(
            'P00058.installation.pompe.speedUnit.enSavoirPlus',
          ) +
          ' ' +
          this.actionStack!.getValue('pvSVitesseMaxRpm') +
          this.translateService.instant(
            'P00058.installation.pompe.speedUnit.enSavoirPlus.rpm',
          ),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  onSpeed1Change(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV1',
      value,
    );
    this.actionStack!.commit();
  }

  onSpeed2Change(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV2',
      value,
    );
    this.actionStack!.commit();
  }

  onSpeed3Change(value: any) {
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PompeVS_Parametrage1,
      'pvPVitesseV3',
      value,
    );
    this.actionStack!.commit();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00058ProgrammeFiltrationAuto =
    P00058ProgrammeFiltrationAuto;
  protected readonly P00058SeuilTemperatureFiltration2424 =
    P00058SeuilTemperatureFiltration2424;
  protected readonly P00058SeuilTemperatureHorsGel =
    P00058SeuilTemperatureHorsGel;
  protected readonly P00058CapteurTemperatureEnum =
    P00058CapteurTemperatureEnum;
}
